import { Injectable } from '@angular/core'
import { EmployeeConfigurationModel } from '../../shared/models/employee-setup.model';
import { AddressConfigurationModel, AllowedAddressFeilds, RequiredAddressFeilds, FieldsTitle } from '../../shared/models/address-details.model';
import { DepartmentConfigurationModel } from 'src/app/shared/models/department-setup.model';
import { RequestFormConfigurationModel } from 'src/app/shared/models/request-form.model';
import { AssignToConfigurationModel } from 'src/app/shared/models/assign-to.model';
import { ApprovalConfigurationModel } from 'src/app/shared/models/approval-data.model';
import { AddCommentConfigurationModel } from 'src/app/shared/models/add-comment.model';
import { DocumentConfigurationModel } from 'src/app/shared/models/document';

@Injectable()
export class IMVOSession {
  employeeConfiguration: EmployeeConfigurationModel = new EmployeeConfigurationModel();
  addressConfiguration: AddressConfigurationModel = new AddressConfigurationModel();
  departmentConfiguration: DepartmentConfigurationModel = new DepartmentConfigurationModel();
  requestFormConfigurationModel: RequestFormConfigurationModel = new RequestFormConfigurationModel();
  approvalConfig: ApprovalConfigurationModel = new ApprovalConfigurationModel();
  documentConfiguration: DocumentConfigurationModel = new DocumentConfigurationModel();
  documentConfigurationNewComment: DocumentConfigurationModel = new DocumentConfigurationModel();
  documentConfigurationEachComment: DocumentConfigurationModel = new DocumentConfigurationModel();
  assignToConfig: AssignToConfigurationModel = new AssignToConfigurationModel();
  addCommentConfig: AddCommentConfigurationModel = new AddCommentConfigurationModel();

  gridReportAllowDelete: boolean = false;
  constructor() {
    let userRoles = localStorage.getItem("Roles");
    if (userRoles != undefined && (userRoles.indexOf('IMVOadmin') > -1 || userRoles.indexOf('IMVOSuperAdmin') > -1)) {
      this.gridReportAllowDelete = true;
    }
    else {
      this.gridReportAllowDelete = true;
    }

  }

  omit_special_char(event) {
    var k;
    var val;
    k = event.charCode;
    if (((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 58)) || (k == 45)) {
      val = true;
    }
    else {
      val = false;
    }
    return val;
  }

  // Only Number Allowed
  numberOnly(event: any) {
    const pattern = /[0-9\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault(); // invalid character, prevent input
    }
  }

  charOnly(event: any) {
    const pattern = /[A-Z a-z\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault(); // invalid character, prevent input
    }
  }


  //Assign To configuration
  async getAssignToConfigurationModel() {
    this.assignToConfig = new AssignToConfigurationModel();
    this.assignToConfig.formId = "IMVO-REQU";
    this.assignToConfig.displayListCardView = false;
    this.assignToConfig.allowAdd = false;
    this.assignToConfig.allowedFields.jobInstructions = false;
    this.assignToConfig.fieldsTitle.jobStartDateTime = "Assigned Date";
    this.assignToConfig.fieldsTitle.expectedCompletionDateTime = "Add Date";
    this.assignToConfig.templateName = "static-ui";
    this.assignToConfig.autoSave = true;
    this.assignToConfig.bulkAssignTo = false;
    this.assignToConfig.allowedFields.actualCompletionDateTime = false;
    this.assignToConfig.requiredFields.expectedCompletionDateTime = false;
    return this.assignToConfig;
  }

  async getEmployeeConfiguration() {
    this.employeeConfiguration = new EmployeeConfigurationModel();
    this.employeeConfiguration.formId = "IMVO-EMPL";
    this.employeeConfiguration.formTitle = "Employee List";
    this.employeeConfiguration.addFormName = "Add Employee";
    this.employeeConfiguration.editFormName = "Edit Employee";
    this.employeeConfiguration.listReportFormName = "Saved Employee List";
    this.employeeConfiguration.addEditInModalPopUp = false;
    this.employeeConfiguration.allowAdd = true;
    //this.employeeConfiguration.allowEdit = true;
    //this.employeeConfiguration.allowDelete = true;
    this.employeeConfiguration.displayListCardView = true;
    this.employeeConfiguration.displayContractorDropDownList = false;
    this.employeeConfiguration.displayDepartmentDropDownList = true;
    this.employeeConfiguration.requiredFields = { employeeCode: false, firstName: true, lastName: true, mobile: true, telephone: false, email: true, profileImage: false, webLogin: false, appenateUser: false, designation: true };
    this.employeeConfiguration.allowedFields = { employeeCode: false, firstName: true, lastName: true, mobile: true, telephone: true, email: true, profileImage: true, webLogin: true, appenateUser: false, designation: true };
    this.employeeConfiguration.employeeRoles = ["imvoEmployee"];
    this.employeeConfiguration.fieldsTitle = { telephone1: "Mobile", telephone2: "Office Phone" };
    this.employeeConfiguration.autoGenerateEmployeeCode = false;
    this.employeeConfiguration.appenateCreateUser.type = "Standard";
    let userRoles = localStorage.getItem("Roles");

    //IMVOlogicadmin,superadminIMVOlogic
    if (userRoles != null && (userRoles.indexOf('IMVOadmin') > -1 || userRoles.indexOf('imvosuperadmin') > -1)) {
      this.employeeConfiguration.allowAdd = true;
      this.employeeConfiguration.allowEdit = true;
      this.employeeConfiguration.allowDelete = true;
    }
    else {
      this.employeeConfiguration.allowAdd = false;
      this.employeeConfiguration.allowEdit = true;
      this.employeeConfiguration.allowDelete = false;
    }

    this.employeeConfiguration.fieldsFormat.telephone1 = this.getTextFormat("telephone");
    this.employeeConfiguration.fieldsFormat.telephone2 = this.getTextFormat("mobile");

    return await this.employeeConfiguration;
  }
  async getDepartmentConfiguration() {
    this.departmentConfiguration = new DepartmentConfigurationModel();
    this.departmentConfiguration.formId = "IMVO-DEPT";
    this.departmentConfiguration.formTitle = "Department List";
    this.departmentConfiguration.addFormName = "Add Department";
    this.departmentConfiguration.editFormName = "Edit Department";
    this.departmentConfiguration.listReportFormName = "Saved Department List";
    this.departmentConfiguration.addEditInModalPopUp = false;
    this.departmentConfiguration.allowAdd = true;
    this.departmentConfiguration.allowEdit = true;
    this.departmentConfiguration.allowDelete = true;
    this.departmentConfiguration.displayListCardView = true;

    this.departmentConfiguration.requiredFields = { parentDepartment: false, departmentCode: true, departmentName: true, telephone: true, email: true };
    this.departmentConfiguration.allowedFields = { parentDepartment: true, departmentCode: true, departmentName: true, telephone: true, email: true };
    // this.departmentConfiguration.departmentRoles = ["IMVOLogicDepartment"];
    this.departmentConfiguration.fieldsTitle = { telephone1: "Mobile", telephone2: "Office Phone" };
    this.departmentConfiguration.autoGenerateDepartmentCode = false;
    let userRoles = localStorage.getItem("Roles");

    //IMVOlogicadmin,superadminIMVOlogic
    if (userRoles != null && (userRoles.indexOf('IMVOadmin') > -1 || userRoles.indexOf('IMVOSuperAdmin') > -1)) {
      this.departmentConfiguration.allowAdd = true;
      this.departmentConfiguration.allowEdit = true;
      this.departmentConfiguration.allowDelete = true;
    }
    else {
      this.departmentConfiguration.allowAdd = false;
      this.departmentConfiguration.allowEdit = true;
      this.departmentConfiguration.allowDelete = false;
    }

    this.departmentConfiguration.fieldsFormat.telephone1 = this.getTextFormat("telephone");
    //this.departmentConfiguration.fieldsFormat.telephone2 = this.getTextFormat("mobile");
    return await this.departmentConfiguration;
  }

  async getRequestFormConfiguration() {
    this.requestFormConfigurationModel = new RequestFormConfigurationModel();
    this.requestFormConfigurationModel.formId = "IMVO-REQU";
    this.requestFormConfigurationModel.formTitle = "Tickets";
    this.requestFormConfigurationModel.addFormName = "Add Ticket";
    this.requestFormConfigurationModel.editFormName = "Edit Ticket";
    this.requestFormConfigurationModel.listReportFormName = "";
    this.requestFormConfigurationModel.addEditInModalPopUp = false;
    this.requestFormConfigurationModel.allowAdd = true;
    this.requestFormConfigurationModel.allowEdit = true;
    this.requestFormConfigurationModel.allowDelete = true;
    this.requestFormConfigurationModel.displayListCardView = true;
    this.requestFormConfigurationModel.allowedFields.attachFile = false;

    return this.requestFormConfigurationModel;
  }

  async getApprovalConfiguration() {
    this.approvalConfig = new ApprovalConfigurationModel();
    this.approvalConfig.formId = "IMVO-REQU";
    this.approvalConfig.formTitle = "Approval Process";
    this.approvalConfig.addFormName = "Approve / Reject";
    this.approvalConfig.editFormName = "";
    this.approvalConfig.listReportFormName = "";
    this.approvalConfig.addEditInModalPopUp = true;
    this.approvalConfig.allowAdd = true;
    this.approvalConfig.allowEdit = true;
    this.approvalConfig.allowDelete = true;
    this.approvalConfig.displayListCardView = false;

    return this.approvalConfig;
  }
  //comment config for Request form (IMVO-REQU)
  async getAddCommentConfig() {
    this.addCommentConfig = new AddCommentConfigurationModel();
    this.addCommentConfig.formId = 'IMVO-REQU';
    this.addCommentConfig.isDeletable = false;
    return this.addCommentConfig;
  }

  //document config for Request form (IMVO-REQU)
  async getDocumentConfigForRequest() {
    this.documentConfiguration.formId = "IMVO-REQU";
    this.documentConfiguration.storageName = "AttachmentFiles";
    this.documentConfiguration.formTitle = "Attach Files";
    this.documentConfiguration.addFormName = "Upload Documents";
    this.documentConfiguration.editFormName = "Edit Document";
    this.documentConfiguration.listReportFormName = "Saved Document List";
    this.documentConfiguration.allowphotosOnly = false;
    this.documentConfiguration.fileNameDiv = false;
    this.documentConfiguration.fileuploadDiv = false;
    this.documentConfiguration.fileclearDiv = false;
    this.documentConfiguration.selectSubmit = true;
    this.documentConfiguration.showMainForm = false;
    this.documentConfiguration.showFileList = true;
    this.documentConfiguration.fileTempTable = true;

    this.documentConfiguration.displayListCardView = false;
    this.documentConfiguration.allowAddMultipleDocuments = true;
    this.documentConfiguration.allowedFields = {
      documentName: false,
      file: true,
      documentType: false,
      documentCategory: false,
      description: false
    };
    this.documentConfiguration.allowAdd = true;
    this.documentConfiguration.allowEdit = true;
    this.documentConfiguration.allowDelete = true;
    this.documentConfiguration.requiredFields = {
      documentName: true,
      file: true,
      documentType: false,
      documentCategory: false,
      description: false,
    };
    this.documentConfiguration.autoSave = true;
    this.documentConfiguration.showFileListUploadBtns = true;
    return this.documentConfiguration;
  }

  //document config for New Comment form (IMVO-COMM)
  async getDocumentConfigForNewComment() {
    this.documentConfigurationNewComment.formId = "IMVO-COMM";
    this.documentConfigurationNewComment.storageName = "CommentFiles";
    this.documentConfigurationNewComment.formTitle = "Attach Files";
    this.documentConfigurationNewComment.addFormName = "Upload Documents";
    this.documentConfigurationNewComment.editFormName = "Edit Document";
    this.documentConfigurationNewComment.listReportFormName = "Saved Document List";
    this.documentConfigurationNewComment.allowphotosOnly = false;
    this.documentConfigurationNewComment.fileNameDiv = false;
    this.documentConfigurationNewComment.fileuploadDiv = false;
    this.documentConfigurationNewComment.fileclearDiv = false;
    this.documentConfigurationNewComment.selectSubmit = true;
    this.documentConfigurationNewComment.fileTempTable = true;

    this.documentConfigurationNewComment.showMainForm = false;
    this.documentConfigurationNewComment.showFileList = true;
    this.documentConfigurationNewComment.displayListCardView = false;
    this.documentConfigurationNewComment.allowAddMultipleDocuments = true;
    this.documentConfigurationNewComment.allowedFields = {
      documentName: false,
      file: true,
      documentType: false,
      documentCategory: false,
      description: false
    };
    this.documentConfigurationNewComment.allowAdd = true;
    this.documentConfigurationNewComment.allowEdit = true;
    this.documentConfigurationNewComment.allowDelete = true;
    this.documentConfigurationNewComment.requiredFields = {
      documentName: true,
      file: true,
      documentType: false,
      documentCategory: false,
      description: false,
    };

    this.documentConfigurationNewComment.saveDocumentFromParent = true;
    this.documentConfigurationNewComment.autoSave = false;
    this.documentConfigurationNewComment.showFileListUploadBtns = true;
    return this.documentConfigurationNewComment;
  }

  //document config for New Comment form (IMVO-COMM)
  async getDocumentConfigForEachComment() {
    this.documentConfigurationEachComment.formId = "IMVO-COMM";
    this.documentConfigurationEachComment.storageName = "CommentFiles";
    this.documentConfigurationEachComment.formTitle = "Attach Files";
    this.documentConfigurationEachComment.addFormName = "Upload Documents";
    this.documentConfigurationEachComment.editFormName = "Edit Document";
    this.documentConfigurationEachComment.listReportFormName = "Saved Document List";
    this.documentConfigurationEachComment.allowphotosOnly = false;
    this.documentConfigurationEachComment.fileNameDiv = false;
    this.documentConfigurationEachComment.fileuploadDiv = false;
    this.documentConfigurationEachComment.fileclearDiv = false;
    this.documentConfigurationEachComment.selectSubmit = true;
    this.documentConfigurationEachComment.fileTempTable = true;

    this.documentConfigurationEachComment.showMainForm = false;
    this.documentConfigurationEachComment.showFileList = true;
    this.documentConfigurationEachComment.displayListCardView = false;
    this.documentConfigurationEachComment.allowAddMultipleDocuments = true;
    this.documentConfigurationEachComment.allowedFields = {
      documentName: false,
      file: true,
      documentType: false,
      documentCategory: false,
      description: false
    };
    this.documentConfigurationEachComment.allowAdd = true;
    this.documentConfigurationEachComment.allowEdit = true;
    this.documentConfigurationEachComment.allowDelete = true;
    this.documentConfigurationEachComment.requiredFields = {
      documentName: true,
      file: true,
      documentType: false,
      documentCategory: false,
      description: false,
    };
    this.documentConfigurationEachComment.selectSubmit = false;
    this.documentConfigurationEachComment.autoSave = false;
    this.documentConfigurationEachComment.showFileListUploadBtns = false;
    return this.documentConfigurationEachComment;
  }


  getTextFormat(type: string) {
    if (type == "telephone") {
      return "###-###-####";
    }
    else if (type == "mobile") {
      return "###-###-####";
    }
    else {
      return "";
    }
  }
}
